export const headItems = [
  'ID',
  'Company name',
  'Country',
  'Status',
  'Visibility',
  'Actions',
]

export const COMPANY_ID_INDEX = 0
export const COMPANY_NAME_INDEX = 1
export const COUNTRY_INDEX = 2
export const STATUS_INDEX = 3
export const INDICATOR_INDEX = 4

export const IN_PROGRESS = 'in progress'
export const COMPLETED = 'completed'
export const NO_PROFILE = 'no profile'

export const INDICATOR_STYLES: Record<string, string> = {
  [IN_PROGRESS]: 'in-progress',
  [COMPLETED]: 'completed',
  [NO_PROFILE]: 'no-profile',
}

export const PROFILE_DETAILS_FORM_ID = 'profile-details-form'
